import { PipeTransform, Pipe } from '@angular/core';
import { pipe } from 'rxjs';
import { PortfolioState } from '../models/portfolioState.model';
import { CollectionManagement } from '../models/collectionManagement.model';

@Pipe({
  name: 'portfolioStateFilter'
})

export class PortfolioStateFilterPipe implements PipeTransform {
  transform(items: PortfolioState[], args: any) {

    if (args.hasOwnProperty('fkIdPortfolioState') && typeof items !== 'undefined') {

      let filteredItems = items.filter(item => item.idPortfolioState == args.fkIdPortfolioState);

      if (filteredItems.length > 0) {
        return filteredItems[0].portfolioStateName;

      } else {
        return "Sin resultado";
      }
    }
    return "Sin resultado";
  }
}
